export default "__VITE_ASSET__BAfURfre__"